import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import danceIcon from '../../img/icons/DanceLogIn.png';

const danceMarker = new L.Icon({
  iconUrl: danceIcon,
  iconSize: [36, 36],
  iconAnchor: [18, 36],
  popupAnchor: [0, -36],
});

const EventMap = ({ lat, lng, title }) => {
  if (!lat || !lng) {
    return (
      <div className="map-placeholder">
        <i className="bi bi-map"></i>
      </div>
    );
  }

  return (
    <div className="event-map-container">
      <MapContainer
        key={`${lat}-${lng}`}
        center={[lat, lng]}
        zoom={14}
        scrollWheelZoom={false}
        style={{ height: '180px', width: '100%' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={[lat, lng]} icon={danceMarker}>
          <Popup>{title || 'Event Location'}</Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export default EventMap;
